autoslash.createNamespace("autoslash.confirm");
autoslash.register(autoslash.confirm);

autoslash.confirm.initialize = function (element) {
    "use strict";
    element.find("[data-autoslash-confirm]").each(function(index, instance) {
        var message = $(instance).data("autoslash-confirm");
        $(instance).click(function() {
            if (confirm(message)) {
                var onCofirmedHandler = $(this).data("autoslash-confirm-onconfirmed");
                if (onCofirmedHandler) {
                    Function(onCofirmedHandler)($(this));
                }
                return true;
            }
            else
            {
                var onCancelledHandler = $(this).data("autoslash-confirm-oncancelled");
                if (onCancelledHandler) {
                    Function(onCancelledHandler)($(this));
                }
                return false;
            }
        });
    });
}